import React from "react";

export const Sparkline = ({ value = 0, max = 100, className = "" }) => {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  return (
    <div className={`relative h-1.5 w-full bg-zinc-200 ${className}`}>
      <div
        className="absolute inset-y-0 left-0"
        style={{
          width: `${pct}%`,
          background:
            value >= 70 ? "#00B140" : value >= 40 ? "#FFB000" : "#A0A0A0",
        }}
      />
    </div>
  );
};

export const RelevanceBadge = ({ score = 0 }) => {
  let bg = "#A0A0A0";
  let label = "Low";
  if (score >= 90) { bg = "#002FA7"; label = "Direct fit"; }
  else if (score >= 70) { bg = "#00B140"; label = "High"; }
  else if (score >= 40) { bg = "#FFB000"; label = "Medium"; }
  return (
    <div className="inline-flex items-center gap-2" data-testid={`relevance-badge-${score}`}>
      <span
        className="inline-flex items-center px-2 py-0.5 text-xs font-mono font-bold text-white tracking-wider"
        style={{ backgroundColor: bg }}
      >
        {score}
      </span>
      <span className="text-xs uppercase tracking-wider text-zinc-500">{label}</span>
    </div>
  );
};

export const StatusBadge = ({ status, active, days }) => {
  const map = {
    open: { bg: "#00B140", label: "OPEN" },
    active: { bg: "#00B140", label: "ACTIVE" },
    upcoming: { bg: "#002FA7", label: "UPCOMING" },
    closed: { bg: "#A0A0A0", label: "CLOSED" },
    cancelled: { bg: "#E00000", label: "CANCELLED" },
    awarded: { bg: "#52525B", label: "AWARDED" },
    archived: { bg: "#A0A0A0", label: "ARCHIVED" },
    unknown: { bg: "#A0A0A0", label: "UNKNOWN" },
  };
  let cfg = map[status] || map.unknown;
  if (active && typeof days === "number" && days >= 0 && days <= 7) {
    cfg = { bg: "#FFB000", label: `CLOSING IN ${days}D` };
  }
  return (
    <span
      className="inline-flex items-center px-2 py-0.5 text-[10px] font-mono font-bold text-white tracking-widest"
      style={{ backgroundColor: cfg.bg }}
      data-testid={`status-badge-${status}`}
    >
      {cfg.label}
    </span>
  );
};
